import React from 'react';
import Product from '../Product';

function Socks () {
    return (
        <div>
            <div>
                <Product title="Socks" start={23} end={31} />
            </div>
        </div>
    )
}

export default Socks;